import { DataTable, Spinner } from "@components/ui-kit";
import { Pagination } from "@components/ui-kit/table/pagination";
import { MarkAsUnpaidConfirm } from "@src/components/widgets/Modals/MarkAsUnpaidConfirm";
import { withCan } from "@src/utils/components/permissions";
import { useUpdateURI } from "@src/utils/hooks/useUpdateURI";
import { observer } from "mobx-react-lite";
import { ChangeDatesModal } from "../../shared/change-dates-modal";
import {
  useFetchTableData,
  useFetchTableOptions,
  useUpdateStoreFromURI,
} from "../hooks";
import { useStore } from "../store";
import { FilterPanel } from "./FilterPanel";
import { NavBar } from "./NavBar";
import { Summary } from "./Summary";
import { Table } from "./Table";

export const Container = withCan(
  {
    do: [
      "outgoingInvoice_read_all",
      "outgoingInvoice_read_own",
      "outgoingInvoice_read_team",
    ],
  },
  observer(function Container() {
    const store = useStore();

    useUpdateStoreFromURI();
    useUpdateURI(store.urlParams);

    const { loading: loadingTableOptions } = useFetchTableOptions();
    const { loading: loadingTableData, loadingSummary } = useFetchTableData();
    const loading = loadingTableData || loadingTableOptions;
    return (
      <DataTable>
        {loading && <Spinner absolute />}
        <NavBar />
        <hr />
        <FilterPanel />
        <Summary isLoaded={!loadingSummary} />
        <Table />
        <ChangeDatesModal store={store.changeDatesModalStore} />
        <MarkAsUnpaidConfirm
          isOpen={store.markAsUnpaidModal.isOpen}
          onClose={store.markAsUnpaidModal.onClose}
          isProforma
          hasMatchedPayments={
            store.markAsUnpaidModal.additionalData?.hasMatchedPayments ?? false
          }
          isLoading={store.isMarkingAsUnpaid}
          onConfirm={store.markAsUnpaid}
        />
        <Pagination store={store.pagination} />
      </DataTable>
    );
  }),
);
